import {getEnv} from '../../common/env/env';
import {BannerItemDto} from '../../common/shared/api/gateway/BannerItemDto.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {ItemType, OnAirItem} from '../generated/types';

export function createOnAirItem({item}: {item: BannerItemDto}): OnAirItem {
  const {title, scheme, thumbnail, video_url, caption} = item;
  return {
    id: `onair-${video_url}`,
    type: ItemType.OnAir,
    title,
    // subtitleList: subtitle_list,   // TODO: subtitle_list 스펙 확인
    scheme,
    videoUrl: video_url,
    thumbnail: thumbnail.startsWith('http')
      ? thumbnail
      : getKageUrl({
          kageUrlPrefix: getEnv().kageUrlPrefix,
          kageId: thumbnail,
          resolution: 'th3',
        }),
    caption,
  };
}
